// extracted by mini-css-extract-plugin
export default {"priceWrapper":"priceWrapper-ub_vB","button":"button-QZue7"};